export default {
  categoryInfo: {
    mainTitle: 'Seyahat Sağlık Sigortası',
    description: {
      title: 'Seyahat Sağlık Sigortası Nedir?',
      content: [
        'Seyahat sağlık sigortası, kişinin iş seyahati veya tatil gibi nedenlerle planladığı programlarını güvence altına alan sigorta ürünüdür. Hem yurtiçinde hem de yurt dışında yapmış olduğunuz seyahatlerde karşılaşabileceğiz hastalık risklerine karşı güvence sağlar.',
        'Seyahat sağlık sigortası, ülke içinde veya ülke dışında meydana gelen beklenmedik yaralanma veya hastalıklar nedeniyle belirli seyahat faydalarının yanı sıra acil tıbbi tedavi teminatı da sağlar. Seyahatinizde öngöremediğiniz birçok durum vardır. Tüm bu beklenmedik durumları güvence altına almak için seyahat sağlık sigortası yaptırmanız önemlidir.',
        'Seyahat sağlık sigortası fiyatlarını karşılaştırmak için “teklif al” formunu doldurmanız yeterlidir.'
      ]
    },
    subContent: {
      title: 'Seyahat Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası teminatları sigorta şirketleri arasında farklılık göstermektedir.',
          subList: [
            'Acil mesajların iletilmesi',
            'Ani rahatsızlık ve hastalıklara ilişkin tıbbi tedavi teminatı',
            'Bagaj kaybı veya hasarı',
            'İlaç gönderilmesi organizasyonu',
            'Kanuni işlemlerle ilgili kefalet (Borç olarak)',
            'Sigortalının taburcu olduktan sonra ikametgâh adresine nakli',
            'Sigortalının tedavinin verilebileceği en yakın sağlık kuruluşuna seyahati veya nakli',
            'Sigortalıya yapılacak tedavi nedeniyle aile üyelerinden birinin konaklaması',
            'Tıbbi danışmanlık',
            'Vefat eden sigortalının cenaze nakli'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title:
        'Seyahat Sağlık Sigortası Kapsam Dışı Kalan Haller Nelerdir?        ',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası teminatları sigorta şirketleri arasında farklılık göstermektedir.',
          subList: [
            'Seyahat sağlık sigorta teminat kapsamı dışında tutulan haller şirketler arası farkındalık göstermektedir.',
            'Sigortalının kendi ihmali sonucu oluşacak hasarlar,',
            'Sel, deprem, volkanik patlamalar, heyelan fırtına, meteor düşmesi vb. doğal afetler sonucu ortaya çıkan zararlar,',
            'Harp veya harp niteliğindeki harekât, ihtilal, isyan, ayaklanma, terörist aktiviteler ve bunlardan doğan iç kargaşalıklar,',
            'Diş ve göz rahatsızlıkları tedavileri,',
            'Estetik tedavileri kapsam dışı tutulmaktadır.'
          ]
        }
      ]
    },
    {
      title:
        'Seyahat Sağlık Sigortası Genel Şartları Hakkında Bilgi Sahibi Olmalı Mısınız?',
      content: [
        {
          paragraph:
            'Genel şartlar sigorta şirketleri arasında değişiklik göstermemektedir. Bu sebeple her şirketten aldığınız teklifin genel şartlarını incelemenize gerek yoktur.',
          subList: null
        },
        {
          paragraph:
            'İnternetten araştırma yaparken genel şartlara göz atmanız yeterlidir. Satın alacağınız seyahat sağlık sigortasının genel şartlar çerçevesinde oluşturulduğunu bilmeniz avantajınıza olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: '30000 Euro Teminatlı Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            '30000 Euro teminatlı seyahat sağlık sigortası poliçesi Schengen vizesi başvurusunda istenmektedir. Schengen vizesi için başvuru yapıyorsanız 30.000 Euro sigorta teminatı bulunan seyahat sağlık sigortası sizden talep edilecektir.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası 92 Gün Kuralı Ne Demek?        ',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçeleri, haftalık, aylık, 3 aylık, 6 aylık ya da 1 yıllık süre kapsamında düzenlenebilen sigorta poliçesidir. Satın alınan her sigorta poliçesinde dikkat edilmesi gereken durumlar olduğu gibi seyahat sağlık sigortası alırken de 92 gün kuralına dikkat etmelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Poliçenizde 92 gün kuralı bulunuyorsa, bu kapsamda yurt dışı seyahati gerçekleştirmeniz durumunda seyahate çıktığınız süreden itibaren 92 gün içerisinde vatandaşı olduğunuz ülkeye geri dönmeniz gerektiği anlamını taşır.',
          subList: null
        },
        {
          paragraph:
            'Yurt dışı seyahatleriniz daha uzun oluyorsa poliçenizde 92 gün kuralının bulunmamasına dikkat etmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Yurt Dışı Seyahat Sağlık Sigortasının Faydaları Nelerdir?          ',
      content: [
        {
          paragraph:
            'Yurt dışı seyahatinizin beklenmedik durumlara karşı teminat altına alınması için kapsamlı bir seyahat sağlık sigortası programına sahip olmanız vazgeçilmezdir.              ',
          subList: [
            'Seyahat sağlık sigortası poliçeniz, tatilinizde kaliteli zaman geçirmenizi ve olası riskler konusunda en az endişelenmenizi sağlamak için hazırlanmıştır.',
            'Seyahatiniz sırasında sizi tüm olası risklere karşı korumayı planlayan sigorta poliçesidir. Büyük potansiyel risklere karşı güvende olduğunuzu bildiğinizde, gönül rahatlığıyla seyahat edebilir ve tatilinizin tadını sonuna kadar çıkarabilirsiniz.',
            'Yurt dışında bir hırsızlık kurbanıysanız, bavulunuzu veya diğer değerli eşyalarınızı kaybettiyseniz, sigorta şirketinizle hemen iletişime geçebilirsiniz.',
            'Seyahat sağlık sigortası poliçeniz, yurt dışı turunuz sırasında size her türlü riske karşı kapsamlı finansal koruma sunar.'
          ]
        },
        {
          paragraph:
            'Satın alacağınız poliçelerde Alokasko.com sadece bir telefon uzağınızda, böylece yabancı ülkede kendinizi yabancı hissetmezsiniz!',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortasını yurt dışına her ne sebeple olsun seyahat etmek isteyen bireyler yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Ne Zaman Başlar ve Biter?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası poliçe başlangıç ve bitiş tarihleri poliçede yazmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Ne Zaman Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası seyahat başlamadan bir gün önce yapılması gerekmektedir. Olası yoğunluk durumlarında poliçenizi yaptırmayı unutmamak için seyahatinizi planladıktan hemen sonra yaptırmanız önerilmektedir.              ',
          subList: null
        }
      ]
    },
    {
      title:
        'Seyahat Durumunda Seyahat Sağlık Sigortasını Yanımda Taşımalı Mıyım?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortanızı poliçe olarak taşımanıza gerek yoktur. Telefonunuzda veya mailinizde bulunması yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası En Az Kaç Günlük Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası en az 3 günlük olarak düzenlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Kesinleştirdiğiniz seyahatlerinizde karışılabileceğiniz sağlık risklerine karşı güvence altında olmanız için tek yapmanız gereken <strong><em><u>alokasko.com</u></em></strong> uzmanlarıyla iletişime geçmenizdir',
          subList: null
        },
        {
          paragraph:
            'Alokasko olarak tüm sigorta ihtiyaçlarınıza cevap verebilmek için uzman kadromuz ile buradayız!',
          subList: null
        }
      ]
    },
    {
      title: 'Erasmus Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Yurt dışına öğretim görmek için gidilen seyahatler de yaşanabilecek sağlık risklerine karşı düzenlenen sigorta poliçesidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Schengen Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Schengen ülkelerine yapılacak olan seyahatlerde vize almak için yapılması zorunlu olan sigorta ürünüdür.',
          subList: null
        },
        {
          paragraph:
            'Ek olarak yurt dışı seyahatlerinde kişinin karşılaşabileceği hastalık risklerine karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Vize Seyahat Sağlık Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Vize sağlık sigortası, yurt dışında kazaen karşılaşabileceğiniz yaralanma veya hastalanma sonucu tedavi masraflarınızı güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Vize İçin Seyahat Sağlık Sigortası Nasıl Alınır?      ',
      content: [
        {
          paragraph:
            'Vize için seyahat sağlık sigortası almak için ofisimizden alabileceğiniz gibi online olarak alokasko.com üzerinden de poliçenizi hemen satın alabilirsiniz.            ',
          subList: null
        },
        {
          paragraph:
            'Yapmanız gereken uzman ekibimize sadece bilgilerinizi iletmektir. Vermiş olduğunu bilgiler doğrultusunda uzman ekibimiz sizin için en uygun sigorta poliçesini sunacaktır.            ',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Kaç Gün Geçerlidir?      ',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası sigortalının talebine göre yapılmaktadır. En az 3 gün olarak düzenlenebilen bu sigorta 1 yıllık da düzenlenebilmektedir. Yoğun seyahat edenler primlerden tasarruf etmek için yıllık seyahat sağlık sigortası satın almaktadır.            ',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Covid-19’u Karşılar Mı?      ',
      content: [
        {
          paragraph:
            'Tüm sigorta şirketleri karşılamasa da Covid- 19’u teminat kapsamına almış olan şirketler bulunmaktadır.            ',
          subList: null
        }
      ]
    },
    {
      title:
        'Kaza ve Hastalık Durumlarında Seyahat Sağlık Sigortası Nasıl Kullanılır?      ',
      content: [
        {
          paragraph:
            'Kaza veya hastalık durumunda yapmanız gereken sadece anlaşmalı hastaneye giderek seyahat sağlık sigortanızınız olduğunu bildirmektedir.            ',
          subList: null
        },
        {
          paragraph:
            'T.C. Kimlik Numaranızı iletmeniz sonucunda gerekli tedavi ve tetkiklerden poliçe limitleri dahilinde yararlanabilirsiniz.            ',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Hesaplama Nasıl Yapılır?      ',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası hesaplaması seyahat edilecek ülke bilgileri, seyahat süresi ve sigortalanmak isteyen kişinin bilgileri doğrultusunda hesaplanmaktadır. Bu bilgiler şirketlere iletilerek sizin için en uygun sigorta teklifi hazırlanmaktadır.            ',
          subList: null
        }
      ]
    },
    // {  BURADA TABLO YAPISI OLACAK DAHA SONRA BAKILACAK
    //   title: 'En Uygun Seyahat Sağlık Sigortası Yapan Şirketler Hangileridir?',
    //   content: [
    //     {
    //       paragraph:
    //         'Devlet destekli alacak sigortası, vadeli satışlardan elde edilen ciro ve vadenin süresine göre hesaplanmaktadır.',
    //       subList: null
    //     }
    //   ]
    // }
    {
      title: 'Seyahat Sağlık Sigortası Prim Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sigortanızın ödemesini kredi kartı veya nakit olarak yapabilirsiniz. Bununla beraber ödemelerinizi döviz olaraktan gerçekleştirebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Seyahat Sağlık Sigortası Almak Avantajlı Mı?',
      content: [
        {
          paragraph:
            'Planladığınız seyahatinizi güvence altına almak için zaman kaybetmenize gerek yok!',
          subList: null
        },
        {
          paragraph:
            'İnternetten online seyahat sağlık sigortası fiyatı talep edebilir, karşılaştırma yapabilir ve poliçenizi kolayca satın alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Online seyahat sigortası talebinde bulunmanız sonucunda sizin için birçok şirketi karşılaştırılır ve size en uygun sigorta sunulur.',
          subList: null
        }
      ]
    },
    {
      title:
        'Online Seyahat Sağlık Sigortası Aldım, Seyahatimi Ertelemem Gerekti Ne Yapmalıyım?',
      content: [
        {
          paragraph:
            'Seyahatinizi ertelemek zorunda kaldığınız zaman poliçenizi iptal ettirmeniz mümkünüdür. Bunun için yapmanız gereken tek şey sigorta danışmanınızı 24 saat öncesinden aramanızdır.',
          subList: null
        }
      ]
    },
    {
      title: 'En Ucuz Seyahat Sağlık Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası alırken fiyattan daha çok içerdiği teminatlara bakılmalıdır. Teminatı ne kadar geniş kapsamlı ise fiyatta o oranda artmaktadır. Bu bağlamda en ucuz sigorta her zaman en iyisi olmayabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Seyahat Sağlık Sigortası Nereden Alınır?',
      content: [
        {
          paragraph:
            'En iyi seyahat sağlık sigortasına ulaşmak için <strong><em><u>alokasko.com</u></em></strong> danışmanlarından yardım alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com danışmanları sizin için en iyi teminatları belirleyerek size avantajlı fiyatları sunacaktır. En iyi poliçeyi arıyorsanız, öncelikle seyahatinizi kapsayan tüm durumları güvence altına aldığınızdan emin olmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası iptali poliçe başlamadan <strong><em><u>en geç bir gün</u></em></strong> önce yapılabilmektedir. Poliçe başlamadan önce sigorta satın almış olduğunuz acenteyi arayarak iptalini talep edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Ücretleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası fiyatları, sigortalı bilgilerine ve poliçe kapsamına göre belirlenmektedir. Seyahati planladığınız yer ve zamanda primlerin belirlenmesinde önemlidir. En uygun seyahat sağlık sigortası fiyatına ulaşmak için karşılaştırma yapmanız ve takıldığınız noktada uzman desteği almalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Seyahat Sağlık Sigortası Fiyatı Ne Kadar?',
      content: [
        {
          paragraph:
            'Seyahat sağlık sigortası şirketleri politikalarına, sigortalı bilgilerine ve seyahat edilecek ülkeye göre değişmektedir.',
          subList: null
        },
        {
          paragraph:
            'Online seyahat sağlık sigortası fiyatı almak isteyen müşterilerimiz alaokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
